import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Select, MenuItem, FormControl, InputLabel, Box } from '@mui/material';


const BookingFormPopup = ({ open, onClose }) => {
    const [bookingData, setBookingData] = useState({
        roomType: '',
        guests: '',
        checkInDate: null,
        checkOutDate: null,
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setBookingData({ ...bookingData, [name]: value });
    };

    // const handleDateChange = (name, newValue) => {
    //     setBookingData({ ...bookingData, [name]: newValue });
    // };

    const handleSubmit = () => {
        console.log('Booking data:', bookingData);
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Book a Room</DialogTitle>
            <DialogContent>
                <Box component="form" noValidate autoComplete="off">
                    <FormControl variant="standard" fullWidth margin="normal">
                        <InputLabel id="room-type-label">Collage</InputLabel>
                        <Select
                            labelId="room-type-label"
                            id="room-type"
                            name="roomType"
                            value={bookingData.roomType}
                            onChange={handleChange}
                            label="Collage"
                        >
                            <MenuItem value=""><em>None</em></MenuItem>
                            <MenuItem value="single">Single</MenuItem>
                            <MenuItem value="double">Double</MenuItem>
                            <MenuItem value="suite">Suite</MenuItem>
                        </Select>
                    </FormControl><FormControl variant="standard" fullWidth margin="normal">
                        <InputLabel id="room-type-label">Room Type</InputLabel>
                        <Select
                            labelId="room-type-label"
                            id="room-type"
                            name="roomType"
                            value={bookingData.roomType}
                            onChange={handleChange}
                            label="Room Type"
                        >
                            <MenuItem value=""><em>None</em></MenuItem>
                            <MenuItem value="single">Single</MenuItem>
                            <MenuItem value="double">Double</MenuItem>
                            <MenuItem value="suite">Suite</MenuItem>
                        </Select>
                    </FormControl>
                    <TextField
                        variant="standard"
                        margin="normal"
                        fullWidth
                        id="guests"
                        label="Number of Guests"
                        name="guests"
                        type="number"
                        value={bookingData.guests}
                        onChange={handleChange}
                    />
                    <TextField id="standard-basic"
                               label="Name"
                               fullWidth
                               margin="normal"
                               variant="standard" />
                    <TextField id="standard-basic"
                               label="Phone"
                               fullWidth
                               margin="normal"
                               variant="standard" />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="outlined">Cancel</Button>
                <Button onClick={handleSubmit} variant="contained">Submit</Button>
            </DialogActions>
        </Dialog>
    );
};

export default BookingFormPopup;